import PARTNERS_CONFIG from './partners-config';

import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function GradeBoosterPartner({ className, customPartner, partnerKey }) {
  const partnerConfig = partnerKey === 'custom_partner' ? customPartner : PARTNERS_CONFIG[partnerKey];
  if (!partnerConfig) return null;
  return (
    <div
      className={className}
      css={({ palette, spacing }) => ({
        backgroundColor: palette.background.default,
        borderRadius: spacing(1),
        padding: spacing(1),
        display: 'flex',
        alignItems: 'center',
        gap: spacing(1),
        '& > img': {
          borderRadius: spacing(0.5),
          width: 35,
          height: 35,
          objectFit: 'contain',
        },
      })}
    >
      <img alt={partnerConfig.name} src={partnerConfig.logo} />
      <Typography>
        In partnership with{' '}
        {partnerConfig.url ?
          <MuiLink href={partnerConfig.url} target="_blank" underline="hover">
            {partnerConfig.name}
          </MuiLink>
        : partnerConfig.name}
      </Typography>
    </div>
  );
}
